import heroimageL from "../assets/images/big/Nadine&JP-59-cropped.jpg"
import heroimageS from "../assets/images/small/Nadine&JP-59-cropped.jpg";
import logo from "../assets/logos/Logo_White_LogoName.png"
import image1 from "../assets/images/big/Nadine&JP-65-resize.jpg"
import image2 from "../assets/images/big/Nadine&JP-127_V2.jpg"
import Nav from '../components/Nav'
import HeroImage from "../components/HeroImage";

import { motion } from "framer-motion"
import {fadeIn, container } from '../components/Animations';
import {
  Box,
  Typography,
  Grid,
  Link,
} from '@mui/material'

export default function Home() {
  return (
    <>
    <Nav />
    <Box className="home">
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ height: "100vh" }}
      className="hero"
    >
      <Typography
        className="hero-logo"
        variant="h1"
      >
        <img src={logo} alt="JP & Nadine" className="home-logo"/>
      </Typography>
      <HeroImage imageS={heroimageS} imageL={heroimageL} />
    </Grid>
      <Box
        className="intro"
        component={motion.div}
        variants={fadeIn}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.8 }}
      >
        <p className="title">JP and Nadine are getting married!</p>
        <p className="text">Please join us as we exchange our vows, alongside our family and friends, 
          on 28 August 2022 at three o’clock in the afternoon in Manila, Philippines.</p>
        <div className="link">
          <a target="_blank" rel="noreferrer" href="https://calendar.google.com/event?action=TEMPLATE&tmeid=NDlubmZmaDJndDloMm5sZ2FmamZiZmZiYmQgbDUyZTc4ZWszZW1hOGVwNGRmNWk3cjRtNDRAZw&tmsrc=l52e78ek3ema8ep4df5i7r4m44%40group.calendar.google.com">
            <button className="button">Save the Date</button>
          </a>
        </div>
        
      </Box>
      <Box className="image1">
        <Box
          className="image1"
          component={motion.div}
          variants={fadeIn}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.8 }}
        >
        <img src={image1} alt="" />
        </Box>
      </Box>
      <Box className="information">
        <Box
          className="info"
          component={motion.div}
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <Box 
            className="info1"
            component={motion.div}
            variants={fadeIn}
          >
            <p className="venue">The Church Ceremony</p>
            <p className="location">San Agustin Church</p>
            <p className="loc-details">General Luna St, Manila,</p>
            <p className="loc-details">1002, Metro Manila, Philippines</p>
            <p className="time">Kindly be there by 2:30PM</p>
            <p className="view-map"><a href="https://goo.gl/maps/KFk4EpQsXwYSNByQ7" target="_blank" rel="noreferrer">View map</a></p>
          </Box>
          <div className="vertical-line"></div>
          <Box
            className="info2"
            component={motion.div}
            variants={fadeIn}
          >
            <p className="venue">Cocktails & Reception</p>
            <p className="location">Oasis Manila - Pavillion</p>
            <p className="loc-details">169 Aurora Blvd, New Manila, San Juan</p>
            <p className="loc-details">1500 Metro Manila, Philippines</p>
            <p className="time">Doors open at 6:00PM</p>
            <p className="view-map"><a href="https://goo.gl/maps/tkFn8dBmkPsJ717g9" target="_blank" rel="noreferrer">View map</a></p>
          </Box>
        </Box>
      </Box>
      <Box className="cta-rsvp" sx={{ padding: {xs: "3em 1em", md: "3em 0", lg: "5em 0"}}}>
        <Typography variant="h2" pb="1em" sx={{color: "white"}}>Are you part of the entourage?</Typography>
        <Link href="/entourage"><button className="click-here">CLICK HERE</button></Link>
      </Box>
      <Box className="image2">
        <img src={image2} alt="" />
      </Box>
      <Box className="footer">
        <p className="text-1">Hope you can celebrate with us!</p>
        <Link href="/rsvp" underline="hover" className="text-2">Let us know by heading to RSVP</Link>
      </Box>
      <Box className="back-to-top">
      </Box>
    </Box>
    </>
  );
}